/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class VatRate {
  vatRateCode: string | undefined = undefined;
  vatCountryCode: string | undefined = undefined;
  vatRateValue: number | undefined = undefined;

  constructor(vatRateCode: string, vatCountryCode: string, vatRateValue: number) {
    this.vatRateCode = vatRateCode;
    this.vatCountryCode = vatCountryCode;
    this.vatRateValue = vatRateValue;
  }
}
